import AOS from 'aos';
import 'aos/dist/aos.css';

import {header} from "./modules/header";
import attachGalleryModalHandlers from "./modules/modal";

document.addEventListener("DOMContentLoaded", function () {
  header().init();
});

window.addEventListener("load", function () {
  attachGalleryModalHandlers();


  AOS.init({
    once: true,
    duration: 800,
    easing: "ease-out-cubic",
    offset: 80,

    disable: function () {
      return window.innerWidth < 1024;
    },
  });
});
